let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("nk9Im")).then(() => parcelRequire('aHUj9'));